module.exports = __webpack_public_path__ + "img/zan.d7bd04aa.png";